
<template>
  <div style="margin-top: 10px">
    <div class="validation-section">
      <div class="row">
        <div class="col-md-12">
          <label>Tipo de Usuario</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <input
            type="radio"
            id="usuarioRegistrado"
            @blur="change"
            v-on:change="cleanPatente"
            v-bind:value="true"
            v-model="IsUsuarioRegistrado"
          />
          <label for="usuarioRegistrado">Usuario Registrado</label>
        </div>
        <div class="col-md-12">
          <input
            type="radio"
            id="usuarioNuevo"
            v-bind:value="false"
            @blur="change"
            v-on:change="cleanPatente"
            v-model="IsUsuarioRegistrado"
          />
          <label for="usuarioNuevo">Usuario No Registrado</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label>Ingrese el Teléfono</label>
        </div>
      </div>
      <div class="row" style="margin-bottom: 0;">
        <div class="col-md-3" style="padding-right: 10px;">
          <base-input
            v-model="model.Aux1"
            :maxlength="4"
            @blur="change"
            onlyNumbers
            placeholder="Prefijo"
          ></base-input>
        </div>
        <div class="col-md-9">
          <base-input
            v-model="model.Aux2"
            :maxlength="8"
            @blur="change"
            onlyNumbers
            placeholder="Número"
          ></base-input>
        </div>
      </div>
      <div v-show="!IsUsuarioRegistrado" class="row">
        <div class="col-md-12">
          <label>Ingrese la Patente</label>
        </div>
      </div>
      <div v-show="!IsUsuarioRegistrado" class="row">
        <div class="col-md-12">
          <base-input
            v-model="model.Aux3"
                        :maxlength="7"
            @blur="change"
            onkeyup="javascript:this.value=this.value.toUpperCase();"
          ></base-input>
        </div>
      </div>
    </div>

    <div class="recarga-section">
      <div class="row">
        <div class="col-md-12">
          <money-with-indicator
            v-model="model.Importe"
            v-on:blur="change"
            v-on:validatedOK="onSaldoOK"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import KitsCombo from "@/components/KitsCombo";
import MoneyWithIndicator from "@/components/Custom/MoneyWithIndicator";

export default {
  components: { KitsCombo, MoneyWithIndicator },
  props: {
    model: {
      Aux1: "",
      Aux2: "",
      Aux3: "",
      Aux4: "",
      Importe: "",
      Validate: false,
      Errors: []
    }
  },
  data() {
    return {
      IsUsuarioRegistrado: false
    };
  },
  mounted() {},

  methods: {
    cleanPatente(val) {
      if (this.IsUsuarioRegistrado) {
        this.model.Aux3 = "";
      }
    },
    change(element) {
      this.validate();
      this.$emit("input", this.model);
    },
    onSaldoOK(val) {
      this.$emit("saldoOK", val);
    },
    validate() {
      let context = this;

        var patenteVieja = /^[a-zA-Z]{3}[0-9]{3}$/;
  var patenteNueva = /^[a-zA-Z]{2}[0-9]{3}[a-zA-Z]{2}$/;

      context.model.Errors = [];
      if (context.model.Aux1 == null || context.model.Aux1.length == 0) {
        context.model.Validate = false;
        context.model.Errors.push("Debe ingresar prefijo");
      } else if (context.model.Aux2 == null || context.model.Aux2.length == 0) {
        context.model.Validate = false;
        context.model.Errors.push("Debe ingresar numero de telefono");
      } else if ((context.model.Aux1.length + context.model.Aux2.length) != 10) {
        context.model.Validate = false;
        context.model.Errors.push("El prefijo y el numero deben sumar 10 digitos");
      } else if (
        !context.IsUsuarioRegistrado &&
        (context.model.Aux3 == null || context.model.Aux3.length == 0)
      ) {
        context.model.Validate = false;
        context.model.Errors.push("Debe ingresar la patente");
        } else if (
        !context.IsUsuarioRegistrado &&
       !(patenteVieja.test(context.model.Aux3)||patenteNueva.test(context.model.Aux3))
      ) {
        context.model.Validate = false;
        context.model.Errors.push("La tente tiene un formato invalido debe ser en formato ABC123 o AB123CD");
      } else if (
        !context.IsUsuarioRegistrado &&
        (context.model.Aux3 != null && context.model.Aux3.length < 5)
      ) {
        context.model.Validate = false;
        context.model.Errors.push(
          "Verifique que la patente contenga al menos cinco caracteres"
        );
      } else if (
        context.model.Aux1 != null &&
        context.model.Aux2 != null &&
        context.model.Aux1.length + context.model.Aux2.length < 10
      ) {
        context.model.Validate = false;
        context.model.Errors.push(
          "Verifique que el número con el prefijo sumen diez dígitos"
        );
      } else if (context.model.Importe <= 0) {
        context.model.Validate = false;
        context.model.Errors.push("El importe no puede ser menor que 0");
      } else {
        context.model.Validate = true;
      }
    }
  }
};
</script>